// extracted by mini-css-extract-plugin
export default {"wrap":"swiper_wrap__YOudR","prev":"swiper_prev__HHris","next":"swiper_next__VZB+I"};